/**
 * @fileoverview POST handler for the "/apps/:app_group_id/territory_edit" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdTerritoryEditCacheKeys } from "./constants";
import type { PostAppsAppGroupIdTerritoryEditProps, TeamEditResult } from "./types";

export const postTeamEdit = reactQueryMutationAdapter(
  appsAppGroupIdTerritoryEditCacheKeys,
  (props: PostAppsAppGroupIdTerritoryEditProps): Promise<TeamEditResult> => {
    return fetch(`/apps/${props.appGroupId}/territory_edit`, "POST", props);
  }
);
